<template>
  <OLink pure class="flex items-center p-4 sm:p-0 rounded-md sm:rounded-none" :href="`yazio/${item.slug}`">
    <YazioAuthorImage :item="item" width="70" height="70" class="rounded-full mr-3 yazio-author-image" />
    <div class="flex flex-col items-start">
      <div class="text-md font-semibold leading-18 mb-1">{{ item.name }}</div>
      <div class="text-sm font-medium leading-18 mb-1">{{ item.title }}</div>
      <div v-if="item.category" class="text-xs px-2 rounded text-primary-300 leading-18 yazio-author-category">
        {{ item.category }}
      </div>
    </div>
  </OLink>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import YazioAuthorImage from './YazioAuthorImage';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: { YazioAuthorImage, OLink },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup({ item }) {
    const profilePictureUrl = getImageUrl({ _id: item.avatarId }, { width: 70, height: 70 });
    return { profilePictureUrl };
  },
});
</script>

<style lang="scss" scoped>
.yazio-author-category {
  border: 1px solid #e2e5ed;
}
.yazio-author-image {
  width: 70px;
  height: 70px;
}

@media (min-width: 640px) {
  .yazio-author-image {
    width: 62px;
    height: 62px;
  }
}
</style>
